"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _carousel_compact_props = _interopRequireDefault(require("./carousel_compact_props"));

var _carousel_props = require("./carousel_props");

var _classname_map = _interopRequireDefault(require("./config/classname_map"));

var _spauiIcon = _interopRequireDefault(require("@tencent/spaui-icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Carousel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Carousel, _PureComponent);

  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Carousel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onChangeIndicatorItem", function (event, index) {
      _this.stopAutoPlay();

      _this.handleChange(event, index);
    });

    _this.state = {
      lastValue: props.value || 0,
      prepareLastValue: -1,
      prepareValue: -1,
      direction: ''
    };

    _this.nullList();

    _this.handlePreviousClick = _this.handlePreviousClick.bind(_assertThisInitialized(_this));
    _this.handleNextClick = _this.handleNextClick.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleTransitionEnd = _this.handleTransitionEnd.bind(_assertThisInitialized(_this));
    _this.handleMouseOver = _this.handleMouseOver.bind(_assertThisInitialized(_this));
    _this.handleMouseOut = _this.handleMouseOut.bind(_assertThisInitialized(_this));
    _this.stopAutoPlay = _this.stopAutoPlay.bind(_assertThisInitialized(_this));
    _this.startAutoPlay = _this.startAutoPlay.bind(_assertThisInitialized(_this));
    _this.next = _this.next.bind(_assertThisInitialized(_this));
    _this.prev = _this.prev.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setControlElementAlignment();
      this.startAutoPlay();

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _nextProps$data = nextProps.data,
          data = _nextProps$data === void 0 ? [] : _nextProps$data;

      if (nextProps.value !== this.props.value) {
        if (data && (this.props.value >= data.length || this.state.prepareValue !== nextProps.value) && nextProps.value < data.length) {
          this.setState({
            lastValue: nextProps.value || 0
          });
        } else {
          this.setState({
            lastValue: this.props.value || 0
          });
        }
      } else {
        this.setState({
          lastValue: nextProps.value || 0,
          prepareLastValue: -1,
          prepareValue: -1,
          direction: ''
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      var _this$props = this.props,
          transitionTime = _this$props.transitionTime,
          value = _this$props.value;
      var _this$state = this.state,
          preLastValue = _this$state.prepareLastValue,
          prepareValue = _this$state.prepareValue,
          lastValue = _this$state.lastValue;
      clearTimeout(this.timeout); // 渲染后，过了动画时间，也需要把对应的值重置会到静止状态的数据

      if (preLastValue > -1 && preLastValue !== prepareValue && prepareValue === value && lastValue === preLastValue) {
        this.timeout = setTimeout(function () {
          _this2.clearLastValue();
        }, transitionTime);
      }

      this.setControlElementAlignment();
      this.startAutoPlay();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.nullList();
    }
  }, {
    key: "nullList",
    value: function nullList() {
      this.timeout = null;
      this.itemParentNode = null;
      this.leftControlRef = null;
      this.rightControlRef = null;
      this.autoPlayInternal = null;
    }
  }, {
    key: "startAutoPlay",
    value: function startAutoPlay() {
      var _this3 = this;

      var _this$props2 = this.props,
          _this$props2$autoPlay = _this$props2.autoPlay,
          autoPlay = _this$props2$autoPlay === void 0 ? false : _this$props2$autoPlay,
          _this$props2$autoPlay2 = _this$props2.autoPlayTime,
          autoPlayTime = _this$props2$autoPlay2 === void 0 ? 3000 : _this$props2$autoPlay2,
          _this$props2$transiti = _this$props2.transitionTime,
          transitionTime = _this$props2$transiti === void 0 ? 0 : _this$props2$transiti;
      var interTime = autoPlayTime > transitionTime ? autoPlayTime : transitionTime;

      if (!this.autoPlayInternal && autoPlay) {
        this.autoPlayInternal = setInterval(function (event) {
          _this3.handleNextClick(event);
        }, interTime);
      }
    }
  }, {
    key: "stopAutoPlay",
    value: function stopAutoPlay() {
      var _this$props$autoPlay = this.props.autoPlay,
          autoPlay = _this$props$autoPlay === void 0 ? false : _this$props$autoPlay;

      if (this.autoPlayInternal && autoPlay) {
        clearInterval(this.autoPlayInternal);
        this.autoPlayInternal = null;
      }
    }
  }, {
    key: "handleMouseOver",
    value: function handleMouseOver(event) {
      var onMouseOver = this.props.onMouseOver;
      this.stopAutoPlay();

      if ((0, _spauiUtils.isFunction)(onMouseOver)) {
        onMouseOver(event);
      }
    }
  }, {
    key: "handleMouseOut",
    value: function handleMouseOut(event) {
      var onMouseOut = this.props.onMouseOut;
      this.startAutoPlay();

      if ((0, _spauiUtils.isFunction)(onMouseOut)) {
        onMouseOut(event);
      }
    }
  }, {
    key: "getClassNameMap",
    value: function getClassNameMap() {
      var _this$props$className = this.props.classNameMap,
          classNameMap = _this$props$className === void 0 ? {} : _this$props$className;
      return _objectSpread({}, _classname_map["default"], {}, classNameMap);
    }
  }, {
    key: "setControlElementAlignment",
    value: function setControlElementAlignment() {
      var _compactProps = (0, _carousel_compact_props["default"])(this.props),
          _compactProps$control = _compactProps.controlElementAlignmentNodeClassName,
          controlElementAlignmentNodeClassName = _compactProps$control === void 0 ? '' : _compactProps$control,
          value = _compactProps.value;

      var currentValue = parseInt(value, 10) || 0;
      var parentNodeRect = {};
      var currentAlignNodeRect = {};
      var controlNodeRect = {};

      if (controlElementAlignmentNodeClassName && this.itemParentNode) {
        var alignNode = this.itemParentNode.querySelectorAll(".".concat(controlElementAlignmentNodeClassName));
        var currentAlignNode = alignNode && alignNode[currentValue];

        if (currentAlignNode && this.itemParentNode && this.itemParentNode.getBoundingClientRect) {
          parentNodeRect = this.itemParentNode.getBoundingClientRect();
          currentAlignNodeRect = currentAlignNode.getBoundingClientRect();

          if (this.leftControlRef && this.leftControlRef.getBoundingClientRect) {
            controlNodeRect = this.leftControlRef.getBoundingClientRect();
            this.leftControlRef.style.top = "".concat(currentAlignNodeRect.top - parentNodeRect.top + (currentAlignNodeRect.height - controlNodeRect.height) / 2, "px");
            this.leftControlRef.style.bottom = 'auto';
            this.leftControlRef.style.marginTop = '0px';
          }

          if (this.rightControlRef && this.rightControlRef.getBoundingClientRect) {
            controlNodeRect = this.rightControlRef.getBoundingClientRect();
            this.rightControlRef.style.top = "".concat(currentAlignNodeRect.top - parentNodeRect.top + (currentAlignNodeRect.height - controlNodeRect.height) / 2, "px");
            this.rightControlRef.style.bottom = 'auto';
            this.rightControlRef.style.marginTop = '0px';
          }
        }
      }
    } // 重置到静止状态的值

  }, {
    key: "clearLastValue",
    value: function clearLastValue() {
      this.setState({
        lastValue: this.props.value || 0,
        prepareLastValue: -1,
        prepareValue: -1,
        direction: ''
      });
    } // 切换到前面一张图片

  }, {
    key: "handlePreviousClick",
    value: function handlePreviousClick(event) {
      var _this$props3 = this.props,
          value = _this$props3.value,
          onChange = _this$props3.onChange,
          data = _this$props3.data;
      var currentValue = parseInt(value, 10) || 0;
      var result = 0;
      this.stopAutoPlay();

      if ((0, _spauiUtils.isFunction)(onChange)) {
        if (currentValue === 0) {
          result = data.length - 1;
        } else {
          result = currentValue - 1;
        }

        this.handleChange(event, result, 'prev');
      }
    } // 组件对外的方法，用于切换到上一张，名称不可更改

  }, {
    key: "prev",
    value: function prev(event) {
      this.handlePreviousClick(event);
    } // 切换下一张

  }, {
    key: "handleNextClick",
    value: function handleNextClick(event) {
      var _this$props4 = this.props,
          value = _this$props4.value,
          onChange = _this$props4.onChange,
          data = _this$props4.data;
      var currentValue = parseInt(value, 10) || 0;
      var result = 0;
      this.stopAutoPlay();

      if ((0, _spauiUtils.isFunction)(onChange)) {
        if (currentValue === data.length - 1) {
          result = 0;
        } else {
          result = currentValue + 1;
        }

        this.handleChange(event, result, 'next');
      }
    } // 组件对外的方法，用于切换下一张，名称不可更改

  }, {
    key: "next",
    value: function next(event) {
      this.handleNextClick(event);
    } // 点击选择图片

  }, {
    key: "handleChange",
    value: function handleChange(event, value) {
      var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var _this$props5 = this.props,
          onChange = _this$props5.onChange,
          _this$props5$data = _this$props5.data,
          data = _this$props5$data === void 0 ? [] : _this$props5$data,
          propsValue = _this$props5.value;
      var lastValue = this.state.lastValue;

      if ((0, _spauiUtils.isFunction)(onChange) && lastValue === propsValue) {
        // 先响应动画数值
        this.setState({
          prepareLastValue: propsValue,
          prepareValue: value,
          direction: direction
        }, function () {
          // 延迟下，等对应的动画class准备好后再响应
          setTimeout(function () {
            onChange(event, value, data[value] || '');
          }, 10);
        });
      }
    }
  }, {
    key: "handleTransitionEnd",
    value: function handleTransitionEnd() {
      this.clearLastValue();
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _compactProps2 = (0, _carousel_compact_props["default"])(this.props),
          itemHeight = _compactProps2.itemHeight,
          AdditionComponent = _compactProps2.AdditionComponent,
          data = _compactProps2.data,
          value = _compactProps2.value,
          LabelComponent = _compactProps2.LabelComponent,
          ItemComponent = _compactProps2.ItemComponent,
          onClickItem = _compactProps2.onClickItem,
          _compactProps2$itemSt = _compactProps2.itemStyle,
          itemStyle = _compactProps2$itemSt === void 0 ? {} : _compactProps2$itemSt,
          _compactProps2$imgSty = _compactProps2.imgStyle,
          imgStyle = _compactProps2$imgSty === void 0 ? {} : _compactProps2$imgSty,
          _compactProps2$indica = _compactProps2.indicatorStyle,
          indicatorStyle = _compactProps2$indica === void 0 ? {} : _compactProps2$indica,
          showIndicator = _compactProps2.showIndicator,
          _compactProps2$innerS = _compactProps2.innerStyle,
          innerStyle = _compactProps2$innerS === void 0 ? {} : _compactProps2$innerS,
          _compactProps2$innerC = _compactProps2.innerClassName,
          innerClassName = _compactProps2$innerC === void 0 ? '' : _compactProps2$innerC,
          PrevArrowComponent = _compactProps2.PrevArrowComponent,
          NextArrowComponent = _compactProps2.NextArrowComponent,
          _compactProps2$contro = _compactProps2.controlStyle,
          controlStyle = _compactProps2$contro === void 0 ? {} : _compactProps2$contro,
          _compactProps2$indica2 = _compactProps2.indicatorSequence,
          indicatorSequence = _compactProps2$indica2 === void 0 ? 'first' : _compactProps2$indica2,
          arrowDisplayType = _compactProps2.arrowDisplayType,
          IndicatorComponent = _compactProps2.IndicatorComponent;

      var _this$state2 = this.state,
          lastValue = _this$state2.lastValue,
          prepareLastValue = _this$state2.prepareLastValue,
          prepareValue = _this$state2.prepareValue,
          _this$state2$directio = _this$state2.direction,
          direction = _this$state2$directio === void 0 ? '' : _this$state2$directio; // 当前选择哪张图片

      var currentValue = parseInt(value, 10) || 0;
      var classNameMap = this.getClassNameMap();
      var showPrevArrow = true;
      var showNextArrow = true; // 第一张时不显示切换上一张的箭头，最后一张不显示切换下一张的箭头

      if (arrowDisplayType === 'auto') {
        showPrevArrow = currentValue != 0;
        showNextArrow = currentValue != data.length - 1;
      }

      var indicator = showIndicator ? _react["default"].createElement("ol", {
        className: classNameMap.CarouselIndicatorsClassName,
        style: indicatorStyle
      }, data.map(function (item, index) {
        var itemValue = ''; // 根据数据值判断下内容

        if (_typeof(item) === 'object' && item) {
          itemValue = item.value;
        } else {
          itemValue = item;
        }

        return _react["default"].createElement("li", {
          key: index,
          "data-value": itemValue,
          className: index === currentValue ? 'active' : '',
          onClick: function onClick(event) {
            _this4.stopAutoPlay();

            _this4.handleChange(event, index);
          }
        });
      })) : null;
      return _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])(classNameMap.Carousel, classNameMap.CarouselSliderClassName)
      }, Carousel), {
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut
      }), indicatorSequence === 'first' ? indicator : null, _react["default"].createElement("div", {
        className: (0, _classnames["default"])(classNameMap.CarouselInnerClassName, innerClassName),
        style: innerStyle,
        ref: function ref(el) {
          return _this4.itemParentNode = el;
        }
      }, data.map(function (item, index) {
        var active = false;
        var prev = false;
        var next = false;
        var left = false;
        var right = false;
        var className = '';

        if (prepareLastValue > -1 && prepareValue > -1 && prepareLastValue !== prepareValue) {
          if ((prepareLastValue < prepareValue || direction === 'next') && direction !== 'prev') {
            if (index === prepareValue) {
              next = true;
            }
          } else {
            if (index === prepareValue) {
              prev = true;
            }
          }
        }

        if (lastValue !== currentValue) {
          // 如果前后值不相等，那就lastValue active
          if (index === lastValue) {
            active = true;
          } // 如果当前值比下一个值大


          if ((currentValue > lastValue || direction === 'next') && direction !== 'prev') {
            if (index === currentValue || index === lastValue) {
              left = true;
            }
          } else {
            if (index === currentValue || index === lastValue) {
              right = true;
            }
          }
        } else {
          // 如果前后值相等，那就active
          if (index === currentValue) {
            active = true;
          }
        }

        className = (0, _classnames["default"])(classNameMap.CarouselItemClassName, {
          active: active,
          next: next,
          prev: prev,
          left: left,
          right: right
        });
        return _react["default"].createElement(ItemComponent, {
          index: index,
          className: className,
          key: index,
          data: item,
          value: currentValue,
          active: index === currentValue,
          itemHeight: itemHeight,
          itemStyle: itemStyle,
          imgStyle: imgStyle,
          onChange: _this4.handleChange,
          onClickItem: onClickItem,
          onTransitionEnd: _this4.handleTransitionEnd,
          LabelComponent: LabelComponent,
          AdditionComponent: AdditionComponent
        });
      })), // 大于1张图片切换才有意义
      data.length > 1 && showPrevArrow ? _react["default"].createElement("a", {
        className: (0, _classnames["default"])(classNameMap.CarouselLeftControlClassName, classNameMap.CarouselControlClassName, {
          'default-arrow': typeof PrevArrowComponent === 'undefined'
        }),
        onClick: this.handlePreviousClick,
        style: controlStyle,
        ref: function ref(el) {
          return _this4.leftControlRef = el;
        }
      }, typeof PrevArrowComponent !== 'undefined' ? PrevArrowComponent : [_react["default"].createElement(_spauiIcon["default"], {
        key: "left-arrow-icon",
        name: "right-arrow-bold-outlined",
        className: classNameMap.CarouselChevronLeftClassName
      }), // <span className={classNameMap.CarouselChevronLeftClassName}></span>
      _react["default"].createElement("span", {
        key: "left-arrow-chevron",
        className: classNameMap.CarouselChevronHiddenClassName
      })]) : null, // 大于1张图片切换才有意义
      data.length > 1 && showNextArrow ? _react["default"].createElement("a", {
        className: (0, _classnames["default"])(classNameMap.CarouselRightControlClassName, classNameMap.CarouselControlClassName, {
          'default-arrow': typeof NextArrowComponent === 'undefined'
        }),
        onClick: this.handleNextClick,
        style: controlStyle,
        ref: function ref(el) {
          return _this4.rightControlRef = el;
        }
      }, typeof NextArrowComponent !== 'undefined' ? NextArrowComponent : [_react["default"].createElement(_spauiIcon["default"], {
        key: "right-arrow-icon",
        name: "right-arrow-bold-outlined",
        className: classNameMap.CarouselChevronRightClassName
      }), // <span className={classNameMap.CarouselChevronRightClassName}></span>
      _react["default"].createElement("span", {
        key: "right-arrow-chevron",
        className: classNameMap.CarouselChevronHiddenClassName
      })]) : null, indicatorSequence === 'last' ? indicator : null, IndicatorComponent ? _react["default"].createElement(IndicatorComponent, {
        onChange: this.onChangeIndicatorItem
      }) : null);
    }
  }]);

  return Carousel;
}(_react.PureComponent); // 组件标记


_defineProperty(Carousel, "propTypes", _carousel_props.propTypes);

_defineProperty(Carousel, "defaultProps", _carousel_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Carousel, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Carousel;
exports["default"] = _default;